import { z } from '@/lib/zod'

export const applicationAccountUsersAuthModel = z.object({
  __typename: z
    .literal('ApplicationAccountUsersAuth')
    .default('ApplicationAccountUsersAuth'),
  id: z.string(),
  applicationAccountUsersId: z.string(),
  subId: z.string(),
  secretData: z.string(),
  hasIntegratedAuthentication: z.boolean(),
  reAuthenticateOnNextLogin: z.boolean(),
  metadata: z.record(z.string()).nullable(),
  isActive: z.boolean(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
})

export type ApplicationAccountUsersAuthModel = z.infer<
  typeof applicationAccountUsersAuthModel
>
